//
//  Wes Anderson movie color palettes
//  https://github.com/karthik/wesanderson
//
export default [
  {
    name: 'bottlerocket1',
    colors: ['#a42820', '#5f5647', '#9b110e', '#3f5151', '#4e2a1e', '#550307', '#0c1707'],
    type: 'wesanderson',
  },
  { name: 'bottlerocket2', colors: ['#fad510', '#cb2314', '#273046', '#354823', '#1e1e1e'], type: 'wesanderson' },
  { name: 'rushmore1', colors: ['#e1bd6d', '#eabe94', '#0b775e', '#35274a', '#f2300f'], type: 'wesanderson' },
  { name: 'rushmore', colors: ['#e1bd6d', '#eabe94', '#0b775e', '#35274a', '#f2300f'], type: 'wesanderson' },
  { name: 'royal1', colors: ['#899da4', '#c93312', '#faefd1', '#dc863b'], type: 'wesanderson' },
  { name: 'royal2', colors: ['#9a8822', '#f5cdb4', '#f8afa8', '#fddda0', '#74a089'], type: 'wesanderson' },
  { name: 'zissou1', colors: ['#3b9ab2', '#78b7c5', '#ebcc2a', '#e1af00', '#f21a00'], type: 'wesanderson' },
  {
    name: 'zissou2',
    colors: [
      '#3a9ab2',
      '#6fb2c1',
      '#91bab6',
      '#a5c2a3',
      '#bdc881',
      '#dccb4e',
      '#e3b710',
      '#e79805',
      '#ec7a05',
      '#ef5703',
      '#f11b00',
    ],
    type: 'wesanderson',
  },
  { name: 'darjeeling1', colors: ['#ff0000', '#00a08a', '#f2ad00', '#f98400', '#5bbcd6'], type: 'wesanderson' },
  { name: 'darjeeling2', colors: ['#eccbae', '#046c9a', '#d69c4e', '#abddde', '#000000'], type: 'wesanderson' },
  { name: 'chevalier1', colors: ['#446455', '#fdd262', '#d3dddc', '#c7b19c'], type: 'wesanderson' },
  { name: 'fantasticfox1', colors: ['#dd8d29', '#e2d200', '#46acc8', '#e58601', '#b40f20'], type: 'wesanderson' },
  { name: 'moonrise1', colors: ['#f3df6c', '#ceab07', '#d5d5d3', '#24281a'], type: 'wesanderson' },
  { name: 'moonrise2', colors: ['#798e87', '#c27d38', '#ccc591', '#29211f'], type: 'wesanderson' },
  { name: 'moonrise3', colors: ['#85d4e3', '#f4b5bd', '#9c964a', '#cdc08c', '#fad77b'], type: 'wesanderson' },
  { name: 'cavalcanti1', colors: ['#d8b70a', '#02401b', '#a2a475', '#81a88d', '#972d15'], type: 'wesanderson' },
  { name: 'grandbudapest1', colors: ['#f1bb7b', '#fd6467', '#5b1a18', '#d67236'], type: 'wesanderson' },
  { name: 'grandbudapest2', colors: ['#e6a0c4', '#c6cdf7', '#d8a499', '#7294d4'], type: 'wesanderson' },
  {
    name: 'isleofdogs1',
    colors: ['#9986a5', '#79402e', '#ccba72', '#0f0d0e', '#d9d0d3', '#8d8680'],
    type: 'wesanderson',
  },
  { name: 'isleofdogs2', colors: ['#ead3bf', '#aa9486', '#b6854d', '#39312f', '#1c1718'], type: 'wesanderson' },
  { name: 'frenchdispatch', colors: ['#90d4cc', '#bd3027', '#b0afa2', '#7fc0c6', '#9d9c85'], type: 'wesanderson' },
  { name: 'asteroidcity1', colors: ['#0a9f9d', '#ceb175', '#e54e21', '#6c8645', '#c18748'], type: 'wesanderson' },
  {
    name: 'asteroidcity2',
    colors: ['#c52e19', '#ac9765', '#54d8b1', '#b67c3b', '#175149', '#af4e24'],
    type: 'wesanderson',
  },
  { name: 'asteroidcity3', colors: ['#fba72a', '#d3d4d8', '#cb7a5c', '#5785c1'], type: 'wesanderson' },
];
